export default __webpack_public_path__ + "static/media/login-bg-21.6479e6cb.jpg";